import { apiClient } from '@/lib/api/apiClient';

export interface SectionDto {
  id: string;
  name: string;
  description?: string;
  imageUrl?: string;
  iconUrl?: string;
  isEnabled: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt?: string;
  categoryCount: number;
  categories?: SectionCategoryDto[];
}

export interface SectionCategoryDto {
  id: string;
  name: string;
  isEnabled: boolean;
}

export interface CreateSectionRequest {
  name: string;
  description?: string;
  imageUrl?: string;
  iconUrl?: string;
  isActive?: boolean;
  displayOrder?: number;
}

export interface UpdateSectionRequest extends CreateSectionRequest {
  id: string;
}

export interface PagedSectionsResult {
  sections: SectionDto[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

const SECTIONS_ENDPOINT = '/api/admin/sections';

export const sectionService = {
  async getAllSections(params?: {
    searchTerm?: string;
    isEnabled?: boolean;
    includeCategories?: boolean;
    page?: number;
    pageSize?: number;
  }): Promise<PagedSectionsResult> {
    const response = await apiClient.get(SECTIONS_ENDPOINT, { params });
    return response.data.data;
  },

  async getSectionById(id: string, includeCategories: boolean = true): Promise<SectionDto> {
    const response = await apiClient.get(`${SECTIONS_ENDPOINT}/${id}`, { 
      params: { includeCategories } 
    });
    return response.data.data;
  },

  async createSection(data: CreateSectionRequest): Promise<{ sectionId: string }> {
    const response = await apiClient.post(SECTIONS_ENDPOINT, data);
    return response.data.data;
  },

  async updateSection(id: string, data: UpdateSectionRequest): Promise<void> {
    await apiClient.put(`${SECTIONS_ENDPOINT}/${id}`, data);
  },

  async toggleSectionStatus(id: string): Promise<void> {
    await apiClient.patch(`${SECTIONS_ENDPOINT}/${id}/toggle-status`);
  },

  async deleteSection(id: string): Promise<void> {
    await apiClient.delete(`${SECTIONS_ENDPOINT}/${id}`);
  },
};
